import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import {
  BookingRecord,
  bookingRecordQuery,
} from "@/app/Bookings/GraphQL/bookingRecordQuery";

export function useBookingRecord(): BookingRecord {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/bookings/_bookingRecordLayout/$bookingId",
  });

  const { data } = useSuspenseGqlQuery(bookingRecordQuery, {
    id: match.params.bookingId,
  });

  return data.booking;
}
